import './public-path'

import './styles/overwrite.css'
import './index.css'
import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import store from '@/store'
import * as serviceWorker from '@/serviceWorkerRegistration'
import i18n, { i18nInitResourcePromise } from './i18n'
import '@/services/sentry'

import App from './App'
import './services/performance'
import { I18nextProvider } from 'react-i18next'

function render() {
  // 设置loading隐藏root
  document.body.classList.add('loading')
  // 加载完语言之后再展示root
  i18nInitResourcePromise.then(() => document.body.classList.remove('loading'))
  ReactDOM.render(
    <Provider store={store}>
      <Suspense fallback={null}>
        <I18nextProvider i18n={i18n}>
          <App />
        </I18nextProvider>
      </Suspense>
    </Provider>,

    document.getElementById('root')
  )
}

render()
if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./App', render)
}

if (process.env.NODE_ENV === 'development') {
  serviceWorker.unregister()
} else {
  serviceWorker.register()
}
